/**
 * CoursePrerequisiteService
 * Directed dependency edges between courses. <c>isRequired</c> edges gate the
 * Start CTA until the viewer completes the prerequisite.
 * Route: api/course-prerequisites
 */
import { BaseService } from '../base/BaseService';
export class CoursePrerequisiteService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? CoursePrerequisiteService.DEFAULT_SERVICE_PATH,
            basePath: CoursePrerequisiteService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    getAllRaw() {
        return this.http.get(this.buildUrl(''));
    }
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    getByIdRaw(id) {
        return this.http.get(this.buildUrl(`${id}`));
    }
    /** All prerequisite edges owned by a given course (ordered by OrderNo). */
    async getByCourse(courseId) {
        const response = await this.getByCourseRaw(courseId);
        return response.data ?? [];
    }
    getByCourseRaw(courseId) {
        return this.http.get(this.buildUrl(`by-course/${courseId}`));
    }
    /** All courses that depend on this one (reverse lookup). */
    async getByPrerequisite(prerequisiteCourseId) {
        const response = await this.getByPrerequisiteRaw(prerequisiteCourseId);
        return response.data ?? [];
    }
    getByPrerequisiteRaw(prerequisiteCourseId) {
        return this.http.get(this.buildUrl(`by-prerequisite/${prerequisiteCourseId}`));
    }
    /**
     * Unmet required prerequisites for the current signed-in viewer on a given course.
     * Empty array => <c>CanStart = true</c>.
     */
    async getUnmetForMe(courseId) {
        const response = await this.getUnmetForMeRaw(courseId);
        return response.data ?? [];
    }
    getUnmetForMeRaw(courseId) {
        return this.http.get(this.buildUrl(`course/${courseId}/unmet-for-me`));
    }
    async create(item) {
        const response = await this.createRaw(item);
        return response.data ?? null;
    }
    createRaw(item) {
        return this.http.post(this.buildUrl(''), item);
    }
    async update(id, item) {
        const response = await this.updateRaw(id, item);
        return response.data ?? null;
    }
    updateRaw(id, item) {
        return this.http.put(this.buildUrl(`${id}`), item);
    }
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    deleteRaw(id) {
        return this.http.delete(this.buildUrl(`${id}`));
    }
}
CoursePrerequisiteService.DEFAULT_SERVICE_PATH = 'resources';
CoursePrerequisiteService.BASE_PATH = 'api/course-prerequisites';
//# sourceMappingURL=CoursePrerequisiteService.js.map